import { render, staticRenderFns } from "./editEmail.vue?vue&type=template&id=4fc52452&scoped=true&"
import script from "./editEmail.vue?vue&type=script&lang=js&"
export * from "./editEmail.vue?vue&type=script&lang=js&"
import style0 from "./editEmail.vue?vue&type=style&index=0&id=4fc52452&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc52452",
  null
  
)

export default component.exports